import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BudgetService } from '../../../../../core/services/budget.service';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-budget',
    templateUrl: './budget.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
    styleUrls: ['./budget.component.css']
})
export class BudgetComponent {
  buttonsPermission: any;
  search_text = '';
  data: any[] = [];
  ays: any[] = [];
  summary: any = null;
  selected_data: any;
  loading = false;

  form: any = this.emptyForm();

  readonly CATEGORIES = [
    { value: 'recette', label: 'Recette' },
    { value: 'depense', label: 'Dépense' },
  ];

  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private budgetService: BudgetService,
    private ayService: AcademicYearService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.buttonsPermission = { show: false, add: true, edit: true, delete: true, status: true };
    this.getAll();
    this.getSummary();
    this.getAys();
  }

  emptyForm() {
    return { label: '', category: 'depense', rubric: '', planned_amount: 0, actual_amount: 0, academic_year_id: null, description: '' };
  }

  getAll() {
    this.loading = true;
    this.budgetService.getAll().subscribe((res: any) => {
      this.loading = false;
      this.data = res.data ?? [];
      this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion du budget', err); });
  }

  getSummary() {
    this.budgetService.summary().subscribe((res: any) => {
      this.summary = res.data;
    }, () => {});
  }

  getAys() {
    this.ayService.getAll().subscribe((res: any) => { this.ays = res.data ?? []; }, () => {});
  }

  store(value: any) {
    this.loading = true;
    this.budgetService.store(value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.form = this.emptyForm();
      this.refresh();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion du budget', err); });
  }

  update(value: any) {
    this.loading = true;
    this.budgetService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.refresh();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Gestion du budget', err); });
  }

  delete() {
    if (!this.verifyChecked()) return;
    const confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez-vous vraiment retirer cette ligne budgétaire ?');
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.budgetService.delete(this.selected_data.id).subscribe((res: any) => {
          this.toastrService.success(res.message);
          this.refresh();
        }, (err: any) => AppErrorShow.showError('Gestion du budget', err));
      }
    });
  }

  refresh() { this.getAll(); this.getSummary(); }

  checked(el?: any) { this.selected_data = el; }

  verifyChecked() {
    if (this.selected_data == null) { this.toastrService.warning('Aucun élément sélectionné'); return false; }
    return true;
  }

  add(content: any) {
    this.form = this.emptyForm();
    this.modalService.open(content, { size: 'lg' });
  }

  edit(content: any) {
    if (!this.verifyChecked()) return;
    this.form = { ...this.selected_data };
    this.modalService.open(content, { size: 'lg' });
  }

  dismiss() { this.modalService.dismissAll(); }

  getPage(event: any) { this.pg.p = event; }

  categoryLabel(v: string) { return this.CATEGORIES.find(c => c.value === v)?.label ?? v; }

  executionRate(el: any): number {
    if (!el.planned_amount || el.planned_amount == 0) return 0;
    return Math.round((el.actual_amount / el.planned_amount) * 100);
  }
}
